import { render, staticRenderFns } from "./ReplyAppointingGuardianOfChild.vue?vue&type=template&id=566bc705"
import script from "./ReplyAppointingGuardianOfChild.vue?vue&type=script&lang=ts"
export * from "./ReplyAppointingGuardianOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports